import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.775 4.775a.94.94 0 0 1 .663-.275h4.719a.75.75 0 0 0 0-1.5h-4.72A2.44 2.44 0 0 0 3 5.438v12.211c0 .625.242 1.3.714 1.772a2.44 2.44 0 0 0 1.724.713H17.69c.646 0 1.266-.256 1.723-.713.472-.472.714-1.147.714-1.772v-4.905a.75.75 0 1 0-1.5 0v4.905c0 .271-.113.55-.274.71a.94.94 0 0 1-.663.275H5.438a.94.94 0 0 1-.663-.274 1.05 1.05 0 0 1-.275-.71V5.437c0-.25.099-.488.275-.663m9.578-1.72a.67.67 0 1 0 0 1.34h3.436l-3.91 3.91a.67.67 0 1 0 .947.947l3.91-3.91v3.436a.67.67 0 1 0 1.34 0V3.725c0-.37-.3-.67-.67-.67z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }